import React from "react";
import { MessageCircle, Loader2 } from "lucide-react";
import { useLiveChat } from "../../contexts/LiveChatContext";
import MessageItem from "./MessageItem";

/**
 * MessageList Component - Displays all messages in a conversation
 */
const MessageList = ({ downloadingMedia, onDownloadMedia, messagesContainerRef }) => {
  const { messages, messagesLoading } = useLiveChat();

  return (
    <div ref={messagesContainerRef} className="flex-1 overflow-y-auto p-4 bg-gray-50 scrollbar-hide">
      {messagesLoading ? (
        <div className="flex items-center justify-center py-12">
          <Loader2 size={30} className="animate-spin text-primary" />
        </div>
      ) : messages.length === 0 ? (
        <div className="flex items-center justify-center py-12">
          <div className="text-center">
            <MessageCircle className="w-12 h-12 text-gray-300 mx-auto mb-3" />
            <p className="text-sm text-gray-500">No messages yet</p>
          </div>
        </div>
      ) : (
        <div className="space-y-3">
          {messages.map((message) => (
            <MessageItem
              key={message.id || message.message_id}
              message={message}
              downloadingMedia={downloadingMedia}
              onDownloadMedia={onDownloadMedia}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default MessageList;

